export const changeTemperatureScoreSelectedReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_TemperatureScoreSelected ":
      return action.payload.TemperatureScoreSelected;
    default:
      return state;
  }
};
